import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

// Shared scorecard renderer: the employee sees it in RoleplayPlayerModal after
// a conversation; managers see the identical card in the Records review modal.
// Coaching framing only — met/partial/missed chips, never pass/fail.

const RESULT_STYLES = {
  met: {
    chip: "bg-emerald-100 text-emerald-700",
    label: "Met",
    Icon: CheckCircleIcon,
    iconClass: "text-emerald-500",
  },
  partial: {
    chip: "bg-amber-100 text-amber-700",
    label: "Partially",
    Icon: RemoveCircleOutlineIcon,
    iconClass: "text-amber-500",
  },
  missed: {
    chip: "bg-rose-100 text-rose-700",
    label: "Missed",
    Icon: HighlightOffIcon,
    iconClass: "text-rose-400",
  },
};

export function RoleplayScorecard({ scorecard }) {
  if (!scorecard) return null;
  const criteria = scorecard.criteria || [];

  return (
    <div className="space-y-3">
      {criteria.map((c) => {
        const s = RESULT_STYLES[c.result] || RESULT_STYLES.missed;
        const Icon = s.Icon;
        return (
          <div
            key={c.id}
            className="rounded-lg border border-slate-200 bg-white p-3"
          >
            <div className="flex items-start gap-2.5">
              <Icon className={s.iconClass} style={{ fontSize: 20, marginTop: 1 }} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm font-semibold text-slate-900">
                    {c.label}
                  </span>
                  <span
                    className={`px-2 py-0.5 rounded text-xs font-medium ${s.chip}`}
                  >
                    {s.label}
                  </span>
                </div>
                {c.evidence && (
                  <p className="mt-1.5 text-xs text-slate-500 italic border-l-2 border-slate-200 pl-2">
                    "{c.evidence}"
                  </p>
                )}
                {c.coaching && (
                  <p className="mt-1.5 text-sm text-slate-700">{c.coaching}</p>
                )}
              </div>
            </div>
          </div>
        );
      })}
      {scorecard.overall_coaching && (
        <div className="rounded-lg bg-violet-50 border border-violet-100 p-3">
          <div className="text-xs font-semibold text-violet-700 uppercase tracking-wide mb-1">
            Coach's note
          </div>
          <p className="text-sm text-slate-800">{scorecard.overall_coaching}</p>
        </div>
      )}
    </div>
  );
}

export default RoleplayScorecard;
